module.exports = __webpack_public_path__ + "img/17.fd264e4e.png";